import { render, staticRenderFns } from "./AffiliatesCampaigns.vue?vue&type=template&id=85606a24&"
import script from "./AffiliatesCampaigns.vue?vue&type=script&lang=js&"
export * from "./AffiliatesCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85606a24')) {
      api.createRecord('85606a24', component.options)
    } else {
      api.reload('85606a24', component.options)
    }
    module.hot.accept("./AffiliatesCampaigns.vue?vue&type=template&id=85606a24&", function () {
      api.rerender('85606a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/AffiliatesCampaigns.vue"
export default component.exports